import _ from 'lodash'

import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { SchedulerResourceEnum } from '@/types/enums'
import i18n from '@/i18n'

export class AbsencesEmployeeResource {
  public type = SchedulerResourceEnum.Employee

  private constructor (
    readonly id: number,
    readonly fullName: string,
    readonly planningGroupName: string,
    readonly eventList: Array<EmployeeEvent>,
    readonly IST: string,
    readonly plan: string,
    readonly MGAZ: string,
    readonly MGAZColor: string,
    readonly note: string,
    readonly position?: number | null
  ) {}

  public static createListFromConfiguration (
    employeeList: Array<Employee>,
    planningGroupList: Array<PlanningGroup>,
    eventList: Array<EmployeeEvent>
  ): Array<AbsencesEmployeeResource> {
    const list: Array<AbsencesEmployeeResource> = employeeList.map((item: Employee) => {
      const planningGroup: PlanningGroup | undefined | any = _.find(planningGroupList, {
        planningGroup: item.planningGroupId
      })

      const employeeEventList = eventList.filter((eventItem: EmployeeEvent) => eventItem.employeeId === item.id)

      return new AbsencesEmployeeResource(
        item.id,
        item.fullName,
        planningGroup ? planningGroup.planningGroupName : i18n.t('planningPage.planingGroupMissing').toString(),
        employeeEventList,
        item.IST,
        '',
        item.MGAZ,
        '#000',
        item.note,
        item.position
      )
    })

    return list
  }

  public static createFloaterList (
    employeeList: Array<Employee>,
    planningGroupList: Array<PlanningGroup>,
    eventList: Array<EmployeeEvent>
  ): Array<AbsencesEmployeeResource> {
    const list: Array<AbsencesEmployeeResource> = employeeList.map((item: Employee) => {

      const employeeEventList = eventList.filter((eventItem: EmployeeEvent) => eventItem.employeeId === item.id)

      return new AbsencesEmployeeResource(
        item.id,
        item.fullName,
        i18n.t('planningPage.floater').toString(),
        employeeEventList,
        item.IST,
        '',
        item.MGAZ,
        '#000',
        item.note,
        1
      )
    })

    return list
  }

}
